(function (errorHandling, $, undefined) {
  var self = errorHandling;

  self.Handle = function (data) {
    if ($("#confirmation-dialog").length > 0) {
      Rustig.Modal.close();
    }
    Rustig.Modal.open({ content: data.html });
  }

}(window.errorHandling = window.errorHandling || {}, jQuery));
